/**
 * 系统管理 用户管理
 */
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>用户管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="搜索：">
				<el-select size="small" v-model="formInline.isLock" placeholder="请选择">
					<el-option label="全部" value=""></el-option>
					<el-option label="正常" value="1"></el-option>
					<el-option label="已锁定" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="">
				<el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
			</el-form-item>
			<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
			<el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
		</el-form>
		<!--列表-->
		<el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" type="selection" width="50">
			</el-table-column>
			<el-table-column align="center" sortable prop="userName" label="用户名" width="120">
			</el-table-column>
			<el-table-column align="center" sortable prop="nickName" label="姓名" width="120">
			</el-table-column>
			<el-table-column align="center" sortable prop="status" label="状态" min-width="50">
				<template slot-scope="scope">
					<el-switch :value="scope.row.status=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作" min-width="300">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
					<el-button size="mini" type="success" @click="resetpwd(scope.$index, scope.row)">重置密码</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
		<!-- 编辑界面 -->
		<el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
			<el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
				<el-form-item label="用户名" prop="userName">
					<el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="nickName">
					<el-input size="small" v-model="editForm.nickName" auto-complete="off" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="roleId">
					<el-select size="small" v-model="editForm.roleId" placeholder="请选择" class="userRole">
						<el-option v-for="item in roles" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="公司" prop="companyIds">
					<el-checkbox-group v-model="editForm.companyIds">
						<el-checkbox v-for="item in companyList" :key="item.id" :label="item.id">{{item.companyName}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
// 导入请求方法
import {
	userList,
	userSave,
	userDelete,
	userPwd,
	userExpireToken,
	userFlashCache,
	userLock,
	UserDeptTree,
	UserDeptSave,
	UserDeptdeptTree,
	deptList,
	roleList,
} from '../../api/userMG';
import Pagination from '../../components/Pagination';
export default {
	data() {
		return {
			nshow: true, //switch开启
			fshow: false, //switch关闭
			loading: false, //是显示加载
			title: '添加用户',
			roles: [],
			editFormVisible: false, //控制编辑页面显示与隐藏
			dataAccessshow: false, //控制数据权限显示与隐藏
			unitAccessshow: false, //控制所属单位隐藏与显示
			// 编辑与添加
			editForm: {
				id: '',
				userName: '',
				nickName: '',
				roleId: '',
				companyIds: [],
			},
			// 选择数据
			selectdata: [],
			// rules表单验证
			rules: {
				userName: [
					{
						required: true,
						message: '请输入用户名',
						trigger: 'blur',
					},
				],
				nickName: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
				],
				roleId: [
					{ required: true, message: '请选择角色', trigger: 'blur' },
				],
			},
			// 删除用户
			seletedata: {
				ids: '',
				token: localStorage.getItem('logintoken'),
			},
			// 重置密码
			resetpsd: {
				id: '',
			},
			// 请求数据参数
			formInline: {
				page: {
					current: 1,
					size: 20,
				},
				userName: null,
				isLock: '',
			},
			//用户数据
			userData: [],
			companyList: [],
			defaultProps: {
				children: 'children',
				label: 'name',
			},
			// 选中
			checkmenu: [],
			//参数role
			saveroleId: '',
			// 分页参数
			pageparm: {
				currentPage: 1,
				pageSize: 10,
				total: 10,
			},
		};
	},
	// 注册组件
	components: {
		Pagination,
	},

	/**
	 * 数据发生改变
	 */
	watch: {},

	/**
	 * 创建完毕
	 */
	created() {
		this.getdata(this.formInline);
		this.getRoles();
		this.getCompanys();
	},

	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		// 获取数据方法
		getdata(parameter) {
			// 获取用户列表
			userList(parameter).then((res) => {
				this.loading = false;
				this.userData = res.data.records;
				// 分页赋值
				this.pageparm.currentPage = res.data.current;
				this.pageparm.pageSize = res.data.size;
				this.pageparm.total = res.data.total;
			});
		},
		getRoles() {
			roleList({}).then((res) => {
				this.roles = res.data.roles;
			});
		},
		getCompanys() {
			deptList({}).then((res) => {
				this.companyList = res.data.list;
			});
		},
		// 分页插件事件
		callFather(parm) {
			this.formInline.page.current = parm.currentPage;
			this.formInline.page.size = parm.pageSize;
			this.getdata(this.formInline);
		},
		//搜索事件
		search() {
			this.getdata(this.formInline);
		},
		// 修改type
		editType: function (index, row) {
			this.loading = true;
			let parm = {
				status: '',
				userName: '',
				id: '',
			};
			parm.id = row.id;
			parm.userName = row.userName;
			let lock = row.status;
			if (lock == 1) {
				parm.status = 2;
			} else {
				parm.status = 1;
			}
			// 修改状态
			userLock(parm).then((res) => {
				this.loading = false;
				if (res.success == false) {
					this.$message({
						type: 'info',
						message: res.msg,
					});
				} else {
					this.$message({
						type: 'success',
						message: '状态修改成功',
					});
					this.getdata(this.formInline);
				}
			});
		},
		//显示编辑界面
		handleEdit: function (index, row) {
			this.editFormVisible = true;
			if (row != undefined && row != 'undefined') {
				this.title = '修改用户';
				this.editForm.id = row.id;
				this.editForm.userName = row.userName;
				this.editForm.nickName = row.nickName;
				this.editForm.roleId = row.roleId;
				this.editForm.companyIds = row.companyIds;
			} else {
				this.title = '添加用户';
				this.editForm.id = '';
				this.editForm.userName = '';
				this.editForm.nickName = '';
				this.editForm.roleId = '';
				this.editForm.companyIds = [];
			}
		},
		// 编辑、添加提交方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					// 请求方法
					userSave(this.editForm)
						.then((res) => {
							this.editFormVisible = false;
							this.loading = false;
							this.getdata(this.formInline);
							this.$message({
								type: 'success',
								message: '数据保存成功！',
							});
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error('保存失败，请稍后再试！');
						});
				} else {
					return false;
				}
			});
		},
		// 选择复选框事件
		selectChange(val) {
			this.selectdata = val;
		},
		// 关闭编辑、增加弹出框
		closeDialog(dialog) {
			if (dialog == 'edit') {
				this.editFormVisible = false;
			} else if (dialog == 'perm') {
				this.dataAccessshow = false;
			} else if (dialog == 'unit') {
				this.unitAccessshow = false;
			}
		},
		// 删除用户
		deleteUser(index, row) {
			this.$confirm('确定要删除吗?', '信息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					// 删除
					userDelete({ id: row.id })
						.then((res) => {
							if (res.success) {
								this.$message({
									type: 'success',
									message: '数据已删除!',
								});
								this.getdata(this.formInline);
							} else {
								this.$message({
									type: 'info',
									message: res.msg,
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error('数据删除失败，请稍后再试！');
						});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除！',
					});
				});
		},
		// 重置密码
		resetpwd(index, row) {
			this.resetpsd.id = row.id;
			this.$confirm('确定要重置密码吗?', '信息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					userPwd(this.resetpsd)
						.then((res) => {
							if (res) {
								this.$message({
									type: 'success',
									message: '重置密码成功！',
								});
								this.getdata(this.formInline);
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error('重置密码失败，请稍后再试！');
						});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '取消重置密码！',
					});
				});
		},
	},
};
</script>

<style scoped>
.user-search {
	margin-top: 20px;
}
.userRole {
	width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/user.vue